export default __webpack_public_path__ + "static/media/kitchen5-afterC-480w.9bd22302.webp";